var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPurchaseCard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 246,
    height: 185,
    viewBox: "0 0 246 185",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5438_171265)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 246,
    height: 185,
    fill: "url(#paint0_linear_5438_171265)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.15,
    filter: "url(#filter0_ddd_5438_171265)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0.5,
    cy: -0.5,
    r: 210.5,
    fill: "#FFF2E9"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.15,
    filter: "url(#filter1_ddd_5438_171265)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 134,
    fill: "#FFF2E9"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.15,
    filter: "url(#filter2_ddd_5438_171265)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 74,
    fill: "#FFF2E9"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M171.971 160.611C171.971 161.953 171.726 162.925 171.242 163.501C170.951 163.799 170.596 164.029 170.204 164.173C169.811 164.318 169.391 164.373 168.973 164.336C168.553 164.377 168.128 164.321 167.734 164.171C167.339 164.021 166.986 163.782 166.702 163.473C166.161 162.618 165.911 161.615 165.989 160.61V147.691H160.055V160.907C160.055 163.521 160.843 165.545 162.397 166.922C163.938 168.287 166.15 168.979 168.973 168.979C171.882 168.979 174.12 168.274 175.625 166.882C177.13 165.49 177.907 163.468 177.907 160.893V147.691H171.971V160.611ZM172.801 148.51H177.077V160.896C177.077 163.236 176.398 165.049 175.058 166.287C173.719 167.524 171.665 168.163 168.974 168.163C166.362 168.163 164.336 167.54 162.952 166.315C161.58 165.1 160.885 163.281 160.885 160.91V148.51H165.16V160.611C165.078 161.796 165.388 162.976 166.044 163.972C166.402 164.384 166.855 164.705 167.364 164.911C167.873 165.116 168.424 165.2 168.972 165.155C169.512 165.196 170.054 165.115 170.557 164.919C171.06 164.723 171.512 164.417 171.878 164.024C172.489 163.297 172.799 162.148 172.799 160.611L172.801 148.51Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.619 169H211.192V164.261H202.527V159.913H210.512V155.175H202.527V152.41H211.193V147.671H196.62L196.619 169ZM197.448 148.501H210.364V151.582H201.697V156.001H209.682V159.082H201.697V165.087H210.364V168.168H197.448V148.501Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.518 164.886H219.206C220.565 164.886 221.472 164.877 221.978 164.859C222.566 164.832 223.144 164.697 223.682 164.462C224.195 164.259 224.624 163.89 224.897 163.415C225.149 162.956 225.277 162.44 225.27 161.918C225.3 161.32 225.139 160.728 224.81 160.225C224.472 159.784 224.005 159.456 223.472 159.286C223.017 159.135 222.54 159.06 222.06 159.064C221.513 159.051 220.777 159.044 219.873 159.044H218.516L218.518 164.886ZM219.348 159.863H219.875C220.769 159.863 221.498 159.87 222.042 159.883C222.431 159.878 222.818 159.936 223.188 160.054C223.565 160.169 223.896 160.395 224.139 160.701C224.364 161.066 224.471 161.491 224.443 161.918C224.45 162.302 224.358 162.681 224.174 163.02C223.989 163.336 223.7 163.579 223.354 163.71C222.91 163.905 222.433 164.017 221.947 164.041C221.467 164.057 220.616 164.066 219.346 164.067L219.348 159.863Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.754 158.701C229.112 158.014 228.306 157.496 227.408 157.195C227.984 156.819 228.471 156.326 228.836 155.748C229.38 154.881 229.661 153.879 229.645 152.86C229.661 151.998 229.458 151.146 229.056 150.381C228.642 149.639 228.017 149.033 227.258 148.638C226.544 148.25 225.765 147.99 224.958 147.871C223.812 147.734 222.658 147.675 221.504 147.695H213.91V163.645C213.656 163.734 213.441 163.908 213.303 164.136C213.165 164.365 213.113 164.634 213.155 164.897C213.197 165.16 213.332 165.4 213.534 165.575C213.737 165.751 213.996 165.851 214.265 165.858C214.535 165.865 214.799 165.779 215.011 165.614C215.223 165.45 215.369 165.217 215.426 164.957C215.482 164.696 215.444 164.425 215.319 164.189C215.194 163.954 214.989 163.769 214.74 163.666V148.52H221.504C222.617 148.5 223.73 148.556 224.836 148.687C225.546 148.792 226.233 149.021 226.862 149.363C227.48 149.682 227.99 150.174 228.328 150.777C228.663 151.42 228.831 152.136 228.816 152.86C228.83 153.722 228.595 154.57 228.136 155.304C227.694 156.001 227.042 156.545 226.272 156.86L226.019 156.966V157.688L226.348 157.757C227.419 157.952 228.399 158.478 229.146 159.26C229.864 160.108 230.23 161.194 230.169 162.298C230.188 163.159 230.007 164.013 229.639 164.794C229.304 165.482 228.816 166.087 228.211 166.563C227.51 167.122 226.703 167.536 225.837 167.781C224.734 168.052 223.599 168.177 222.462 168.15H214.379V168.982H222.46C223.672 169.009 224.881 168.874 226.056 168.582C227.028 168.308 227.933 167.844 228.719 167.218C229.422 166.665 229.988 165.963 230.378 165.164C230.802 164.269 231.013 163.289 230.994 162.301C231.059 160.989 230.616 159.702 229.754 158.701V158.701Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.632 168.151H180.893V148.52H185.169V165.076H188.67C188.768 165.257 188.914 165.408 189.092 165.513C189.27 165.618 189.474 165.674 189.682 165.674C189.89 165.674 190.094 165.618 190.272 165.513C190.451 165.408 190.597 165.257 190.695 165.076L190.772 164.893C190.812 164.779 190.834 164.66 190.835 164.539C190.835 164.263 190.734 163.997 190.55 163.79C190.366 163.583 190.112 163.449 189.835 163.413C189.558 163.378 189.278 163.443 189.046 163.597C188.814 163.75 188.647 163.982 188.576 164.248H186V147.692H180.065V168.982H194.462V164.251H193.633L193.632 168.151Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.662 148.512C155.75 148.765 155.924 148.978 156.155 149.117C156.386 149.255 156.658 149.31 156.926 149.271C157.193 149.232 157.438 149.102 157.618 148.903C157.798 148.705 157.902 148.45 157.912 148.184C157.922 147.918 157.838 147.656 157.673 147.445C157.508 147.234 157.274 147.086 157.01 147.028C156.746 146.969 156.47 147.004 156.23 147.125C155.989 147.246 155.799 147.447 155.693 147.691H147.308V152.167H151.962V159.836C151.962 160.533 151.951 161.181 151.929 161.761C151.919 162.24 151.811 162.712 151.614 163.149C151.444 163.524 151.145 163.827 150.771 164.006C150.176 164.26 149.529 164.373 148.882 164.338C148.344 164.353 147.806 164.289 147.288 164.148C146.854 164.012 146.431 163.863 146.033 163.705L145 163.671V168.506L145.329 168.575C146.035 168.718 146.749 168.818 147.467 168.874C148.267 168.943 149.134 168.977 150.042 168.977C151.169 168.993 152.293 168.841 153.374 168.525C154.326 168.236 155.203 167.745 155.943 167.085C156.599 166.502 157.105 165.773 157.418 164.959C157.739 164.122 157.901 163.235 157.896 162.34V152.092H157.066V162.342C157.072 163.135 156.928 163.923 156.644 164.665C156.377 165.359 155.946 165.981 155.387 166.479C154.736 167.058 153.964 167.49 153.125 167.744C152.125 168.035 151.085 168.175 150.042 168.158C149.152 168.158 148.311 168.125 147.539 168.059C146.913 168.005 146.34 167.934 145.83 167.839V164.51C146.216 164.661 146.622 164.803 147.036 164.933C147.636 165.1 148.259 165.178 148.882 165.162C149.662 165.201 150.441 165.055 151.153 164.736C151.692 164.473 152.121 164.033 152.367 163.492C152.609 162.958 152.741 162.381 152.754 161.797C152.777 161.211 152.788 160.552 152.788 159.839V151.346H148.137V148.512H155.662Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.703 156.395C223.142 156.167 223.489 155.798 223.687 155.349C223.893 154.876 223.996 154.366 223.988 153.852C224.016 153.265 223.887 152.681 223.616 152.158C223.367 151.739 222.987 151.41 222.533 151.22C222.171 151.071 221.782 150.996 221.389 150.998C220.948 150.985 220.35 150.979 219.618 150.979H218.519V156.82H219.076C220.177 156.82 220.911 156.811 221.322 156.793C221.806 156.764 222.278 156.628 222.703 156.395V156.395ZM219.191 156.001V151.797H219.618C220.342 151.797 220.932 151.804 221.373 151.817C221.691 151.813 222.006 151.871 222.301 151.988C222.621 152.117 222.891 152.344 223.07 152.635C223.256 153.013 223.341 153.432 223.317 153.852C223.324 154.23 223.25 154.605 223.1 154.953C222.966 155.252 222.732 155.496 222.437 155.644C222.087 155.836 221.697 155.949 221.297 155.974C220.908 155.991 220.219 156 219.189 156.001H219.191Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9596 86.5376C25.9846 86.5376 24.1346 85.9376 22.6096 84.4876C21.3846 83.3376 20.9346 81.3376 20.9346 79.3126V74.5876H24.4346V78.8876C24.4346 80.3626 24.7096 81.4376 25.4846 82.0876C26.3346 82.8126 27.7346 83.0376 29.2096 83.0376H36.2096V72.4626H39.7096V86.5376H28.9596ZM27.7346 71.6626C26.6846 71.6626 25.7846 71.0376 25.7846 69.8626C25.7846 68.8126 26.6346 68.0876 27.7346 68.0876C28.8346 68.0876 29.6846 68.8126 29.6846 69.8626C29.6846 71.0376 28.7846 71.6626 27.7346 71.6626ZM33.1596 71.6626C32.1096 71.6626 31.2096 71.0376 31.2096 69.8626C31.2096 68.8126 32.0596 68.0876 33.1596 68.0876C34.2846 68.0876 35.1096 68.8126 35.1096 69.8626C35.1096 71.0376 34.2096 71.6626 33.1596 71.6626Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.4916 86.5376V66.2626H47.9916V83.0376H51.1916V86.5376H44.4916Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.4648 91.8626C52.4148 91.8626 51.5148 91.2376 51.5148 90.0876C51.5148 89.0126 52.3648 88.2876 53.4648 88.2876C54.5648 88.2876 55.4148 89.0126 55.4148 90.0876C55.4148 91.2376 54.5148 91.8626 53.4648 91.8626ZM58.8898 91.8626C57.8398 91.8626 56.9398 91.2376 56.9398 90.0876C56.9398 89.0126 57.7898 88.2876 58.8898 88.2876C60.0148 88.2876 60.8398 89.0126 60.8398 90.0876C60.8398 91.2376 59.9398 91.8626 58.8898 91.8626ZM50.6898 86.5376V83.0376H55.9148V72.4626H59.4148V86.5376H50.6898Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.1094 92.0376C63.4594 92.0376 62.7594 91.9376 62.3344 91.8126L62.0844 88.3126C62.7344 88.4876 63.2094 88.5376 63.7344 88.5376C65.1344 88.5376 65.6094 87.8126 65.6094 86.0876V72.4626H69.1094V83.0376H71.8094V86.5376H69.0844C68.8844 90.3876 67.4094 92.0376 64.1094 92.0376Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.3197 86.5376V83.0376H76.5447V72.4626H80.0447V83.0376H84.6447V86.5376H71.3197ZM80.8447 70.3376C79.7947 70.3376 78.8947 69.7126 78.8947 68.5376C78.8947 67.4876 79.7447 66.7626 80.8447 66.7626C81.9697 66.7626 82.7947 67.4876 82.7947 68.5376C82.7947 69.7126 81.8947 70.3376 80.8447 70.3376ZM75.4197 70.3376C74.3697 70.3376 73.4697 69.7126 73.4697 68.5376C73.4697 67.4876 74.3197 66.7626 75.4197 66.7626C76.5197 66.7626 77.3697 67.4876 77.3697 68.5376C77.3697 69.7126 76.4697 70.3376 75.4197 70.3376Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.437 73.7126V79.9376C102.487 82.1876 103.737 83.2876 105.587 83.2876C107.562 83.2876 108.587 82.0626 108.587 80.1376V70.7126H112.062V79.6876C112.062 80.5376 111.987 81.3126 111.862 82.0126C112.637 82.6876 114.112 83.0376 115.387 83.0376V86.5376C112.637 86.5376 111.462 85.4876 110.887 84.4626C109.837 86.0376 108.087 86.7876 105.587 86.7876C103.687 86.7876 101.762 86.2376 100.612 84.3876C99.3371 85.7126 97.5371 86.5376 95.6371 86.5376H84.1371V83.0376H89.5871V73.7126H93.0871V83.0376H95.6371C97.1371 83.0376 98.9371 82.3626 98.9371 79.9126V73.7126H102.437ZM103.287 70.1876C102.287 70.1876 101.412 69.5876 101.412 68.4376C101.412 67.4126 102.212 66.7126 103.287 66.7126C104.387 66.7126 105.187 67.4126 105.187 68.4376C105.187 69.5876 104.312 70.1876 103.287 70.1876ZM97.9871 70.1876C96.9871 70.1876 96.1121 69.5876 96.1121 68.4376C96.1121 67.4126 96.9121 66.7126 97.9871 66.7126C99.0621 66.7126 99.8871 67.4126 99.8871 68.4376C99.8871 69.5876 98.9871 70.1876 97.9871 70.1876ZM100.637 66.2126C99.7621 66.2126 98.9621 65.6876 98.9621 64.6876C98.9621 63.7876 99.6621 63.1626 100.637 63.1626C101.612 63.1626 102.312 63.7876 102.312 64.6876C102.312 65.6876 101.537 66.2126 100.637 66.2126Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.85 86.5376V83.0376H117.275C117.15 82.5376 117.1 81.9876 117.1 81.4376C117.1 77.1876 120.45 73.7876 124.575 73.7876C128.8 73.7876 132.175 77.1126 132.175 81.4376C132.175 81.9876 132.1 82.5376 132 83.0376H134.8V86.5376H130.125C128.725 88.0126 126.725 88.9126 124.575 88.9126C122.45 88.9126 120.5 87.9876 119.125 86.5376H114.85ZM124.575 85.4126C126.875 85.4126 128.675 83.7376 128.675 81.3876C128.675 79.0376 126.975 77.2876 124.575 77.2876C122.25 77.2876 120.6 79.1126 120.6 81.3876C120.6 83.6376 122.325 85.4126 124.575 85.4126Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.308 86.5376V83.0376H136.758V66.2626H140.258V86.5376H134.308Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.395 86.5376V66.2626H148.895V86.5376H145.395Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.7596 113.963H25.7596V121.538H22.1596V101.263H29.7596C34.9346 101.263 37.1846 104.288 37.1846 107.463C37.1846 110.838 34.7846 113.963 29.7596 113.963ZM28.9846 104.613H25.7596V110.613H28.9846C31.6096 110.613 33.3846 109.888 33.3846 107.538C33.3846 105.538 31.9596 104.613 28.9846 104.613Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.958 118.063V107.463H51.458V120.813C49.433 121.488 47.858 121.838 45.433 121.838C41.833 121.838 39.058 120.438 39.058 116.063V107.463H42.558V115.063C42.558 117.638 43.358 118.413 45.333 118.413C46.108 118.413 46.933 118.338 47.958 118.063Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.673 107.238V110.588H61.673C61.123 110.588 59.423 110.688 58.998 110.838V121.538H55.498V107.838C57.248 107.488 59.573 107.238 61.023 107.238H63.673Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.26 114.413C65.26 110.163 68.46 106.963 72.81 106.963C74.735 106.963 76.26 107.388 77.685 108.113L76.285 111.263C75.36 110.738 74.26 110.388 72.96 110.388C70.535 110.388 68.935 112.013 68.935 114.413C68.935 116.813 70.535 118.413 72.96 118.413C74.26 118.413 75.36 118.088 76.285 117.538L77.685 120.713C76.26 121.438 74.735 121.838 72.81 121.838C68.46 121.838 65.26 118.688 65.26 114.413Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.9004 101.263V107.263C84.9504 107.088 85.9504 106.963 86.7254 106.963C90.3254 106.963 93.2254 108.113 93.2254 112.738V121.538H89.7254V113.738C89.7254 111.163 88.6504 110.388 86.5754 110.388C85.8254 110.388 84.9004 110.488 83.9004 110.663V121.538H80.4004V101.263H83.9004Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.527 118.288V115.438C104.877 115.263 103.927 115.138 103.152 115.138C101.377 115.138 99.877 115.588 99.877 116.938C99.877 118.238 101.227 118.688 102.952 118.688C103.827 118.688 104.777 118.538 105.527 118.288ZM102.902 121.838C99.377 121.838 96.227 120.613 96.227 117.163C96.227 114.013 98.952 112.388 102.777 112.388C103.527 112.388 104.477 112.438 105.527 112.588V112.388C105.527 110.788 104.202 110.338 102.277 110.338C100.827 110.338 98.702 110.913 97.327 111.588L97.777 108.013C98.902 107.463 100.802 106.963 102.752 106.963C106.377 106.963 109.027 108.438 109.027 112.538V120.738C107.252 121.438 104.977 121.838 102.902 121.838Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.173 118.413C119.598 118.413 120.798 118.113 120.798 117.313C120.798 116.588 120.273 116.238 118.473 115.888L117.348 115.688C114.173 115.088 112.248 113.738 112.248 111.313C112.248 108.663 114.473 106.963 118.123 106.963C120.348 106.963 122.548 107.413 124.098 108.263L122.823 111.513C121.548 110.813 119.523 110.388 117.923 110.388C116.448 110.388 115.723 110.738 115.723 111.313C115.723 111.938 116.273 112.313 118.048 112.663L119.148 112.863C122.998 113.588 124.498 114.963 124.498 117.513C124.498 119.963 122.373 121.838 118.073 121.838C115.798 121.838 113.373 121.288 111.773 120.388L113.098 116.988C114.373 117.813 116.298 118.413 118.173 118.413Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.633 118.413H135.008C136.483 118.413 138.383 117.863 139.133 117.163L140.683 120.288C139.183 121.113 137.308 121.838 134.533 121.838C130.083 121.838 126.808 118.638 126.808 114.413C126.808 110.063 130.133 106.963 134.283 106.963C138.608 106.963 141.733 110.138 141.558 115.563H130.408C130.858 117.488 132.458 118.413 134.633 118.413ZM134.233 110.063C132.358 110.063 130.958 111.163 130.533 112.663H137.883C137.508 110.938 136.133 110.063 134.233 110.063Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.155 118.413C151.58 118.413 152.78 118.113 152.78 117.313C152.78 116.588 152.255 116.238 150.455 115.888L149.33 115.688C146.155 115.088 144.23 113.738 144.23 111.313C144.23 108.663 146.455 106.963 150.105 106.963C152.33 106.963 154.53 107.413 156.08 108.263L154.805 111.513C153.53 110.813 151.505 110.388 149.905 110.388C148.43 110.388 147.705 110.738 147.705 111.313C147.705 111.938 148.255 112.313 150.03 112.663L151.13 112.863C154.98 113.588 156.48 114.963 156.48 117.513C156.48 119.963 154.355 121.838 150.055 121.838C147.78 121.838 145.355 121.288 143.755 120.388L145.08 116.988C146.355 117.813 148.28 118.413 150.155 118.413Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M197.849 -14.9819C193.941 23.4956 209.44 104.179 302.376 120.366M302.376 120.366C302.772 120.435 303.169 120.502 303.569 120.569C397.565 136.27 341.938 126.975 302.376 120.366Z",
    stroke: "white",
    strokeWidth: 1.57009
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M149.627 -1.96711C165.56 33.274 219.464 95.2776 307.969 62.6286M307.969 62.6286C308.346 62.4894 308.724 62.3485 309.103 62.2058C398.281 28.6048 345.504 48.4873 307.969 62.6286Z",
    stroke: "white",
    strokeWidth: 1.57009
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ddd_5438_171265",
    x: -284,
    y: -234,
    width: 569,
    height: 569,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.39155
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.678431 0 0 0 0 0.316718 0 0 0 0 0.0126224 0 0 0 0.01 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5438_171265"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 11.3915
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.26443
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.945098 0 0 0 0 0.501961 0 0 0 0 0.129412 0 0 0 0.02 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_5438_171265",
    result: "effect2_dropShadow_5438_171265"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 51
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 37
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.945098 0 0 0 0 0.501961 0 0 0 0 0.129412 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_5438_171265",
    result: "effect3_dropShadow_5438_171265"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect3_dropShadow_5438_171265",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_ddd_5438_171265",
    x: -208,
    y: -157,
    width: 416,
    height: 416,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.39155
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.678431 0 0 0 0 0.316718 0 0 0 0 0.0126224 0 0 0 0.01 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5438_171265"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 11.3915
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.26443
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.945098 0 0 0 0 0.501961 0 0 0 0 0.129412 0 0 0 0.02 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_5438_171265",
    result: "effect2_dropShadow_5438_171265"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 51
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 37
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.945098 0 0 0 0 0.501961 0 0 0 0 0.129412 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_5438_171265",
    result: "effect3_dropShadow_5438_171265"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect3_dropShadow_5438_171265",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_ddd_5438_171265",
    x: -148,
    y: -97,
    width: 296,
    height: 296,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.39155
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.678431 0 0 0 0 0.316718 0 0 0 0 0.0126224 0 0 0 0.01 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5438_171265"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 11.3915
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.26443
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.945098 0 0 0 0 0.501961 0 0 0 0 0.129412 0 0 0 0.02 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_5438_171265",
    result: "effect2_dropShadow_5438_171265"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 51
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 37
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.945098 0 0 0 0 0.501961 0 0 0 0 0.129412 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_5438_171265",
    result: "effect3_dropShadow_5438_171265"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect3_dropShadow_5438_171265",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5438_171265",
    x1: 0,
    y1: 0,
    x2: 246,
    y2: 185,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.169792,
    stopColor: "#83D7FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.784375,
    stopColor: "#3DC2FF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5438_171265"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 246,
    height: 185,
    rx: 4,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPurchaseCard);
export default __webpack_public_path__ + "static/media/purchaseCard.111c0e350324ff588d3c3d8afa398a05.svg";
export { ForwardRef as ReactComponent };